// extracted by mini-css-extract-plugin
export default {"miniContainer":"GeneralInfo_miniContainer__1tSSa","container":"GeneralInfo_container__3crLt"};